import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'

import Card from '@components/card'
import Title from '@components/text/title'
import FormInput from '@components/inputs/formInput'
import PrimaryButton from '@components/inputs/button/primaryButton'
import Loading from '@components/loading'
import PasswordStrengthChecker from '@components/passwordStrengthChecker'
import TextDivisor from '@components/text/textDivisor'
import PasswordMustHave from '@components/passwordStrengthChecker/passwordMustHave'
import Popup from 'reactjs-popup'
import Footer from '@components/footer'
import showToast from '@util/ToastUtil'

import InsurerLogo from '@components/insurerLogo'

import backgroundImage from '@assets/images/login-background.jpg'

import { resetPassword as resetPasswordAction } from '@actions/user'

import { validateForgotPasswordsFields, invalidPasswordsForgotPassword } from '@util/validationUtil'

import {
  Container, GreenContainer, CardContainer
} from '../styles'
import {
  PasswordNeedsContainer,
  PasswordNeedsLabel,
  PasswordNeedsPopup,
  PasswordNeedsBackground,
} from './styles'

const ChangePasswordByToken = ({ resetPassword }) => {
  const { url } = useParams()
  const [newPassword, setNewPassword] = useState('')
  const [passwordConfirm, setPasswordConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState('')
  const navigate = useNavigate()

  const { insurance } = useParams()

  if (url.search('url') !== -1) {
    decodeURI(url)
    const decodedUrl = url.slice(4, url.length)
    window.location = decodedUrl
  }

  const onError = (data) => {
    setLoading(false)
    if (data.message) {
      const message = data.message.split(':')
      setErrors({
        ...errors,
        newPassword: message[1]
      })
    } else {
      navigate(`/${insurance}/acompanhamento`)
      showToast('success', 'Senha alterada com sucesso')
    }
  }

  const onSave = () => {
    setLoading(true)
    resetPassword(
      {
        token: url,
        password: newPassword,
        newPassword
      },
      onError
    )
  }

  function checkOnUnfocus(label, value1, value2) {
    const error = validateForgotPasswordsFields[label](value1, value2)
    if (error) {
      setErrors({
        ...errors,
        [label]: error
      })
    } else {
      const aux = errors
      delete aux[label]
      setErrors({ ...aux })
    }
  }

  const onChange = (e, setState) => setState(e.target.value)

  return (
    <Container
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <GreenContainer>
        <InsurerLogo />
        <Card style={{ maxHeight: 472 }}>
          <CardContainer>
            <Title style={{ margin: '3vh 0' }}>Recuperar senha</Title>
            <FormInput
              type="password"
              value={newPassword}
              onChange={(e) => onChange(e, setNewPassword)}
              onBlur={() => checkOnUnfocus('newPassword', newPassword)}
              placeholder="Nova senha"
              error={errors.newPassword}
              required
            />
            <FormInput
              type="password"
              value={passwordConfirm}
              onChange={(e) => onChange(e, setPasswordConfirm)}
              onBlur={() => checkOnUnfocus('passwordConfirm', newPassword, passwordConfirm)}
              error={errors.passwordConfirm}
              placeholder="Confirme a nova senha"
              required
            />
            <PasswordStrengthChecker password={newPassword} />
            <TextDivisor height={1} />
            <PasswordNeedsContainer>
              <PasswordNeedsLabel>Requisitos da senha</PasswordNeedsLabel>
              <Popup
                trigger={() => (
                  <div>
                    <PasswordNeedsPopup>Visualizar</PasswordNeedsPopup>
                  </div>
                )}
                on={['hover', 'focus']}
                position="top left"
                closeOnDocumentClick
              >
                <PasswordNeedsBackground>
                  <PasswordMustHave password={newPassword} />
                </PasswordNeedsBackground>
              </Popup>
            </PasswordNeedsContainer>
            <PrimaryButton
              onClick={onSave}
              disabled={loading || invalidPasswordsForgotPassword(newPassword, passwordConfirm)}
            >
              {loading ? <Loading /> : 'Salvar'}
            </PrimaryButton>
          </CardContainer>
        </Card>
        <Footer />
      </GreenContainer>
    </Container>
  )
}

ChangePasswordByToken.propTypes = {
  resetPassword: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    resetPassword: resetPasswordAction,
  },
  dispatch
)

export default connect(null, mapDispatchToProps)(ChangePasswordByToken)
